export default __webpack_public_path__ + "static/media/i (2).5aa0f152.jpg";